import { RiskType } from '../enums';
import yellowBall from '../../assets/yellow.png';
import redBall from '../../assets/red.png';
import pBet from '../../assets/pBet.png';
import greenBall from '../../assets/green.png';
import vbetBall from '../../assets/vbet.png';
import { partnerSkinEnums } from '../../../../core/constants/partnerSkinEnums';

export const plinkoBasis = {
  a: { x: 276, y: 546 },
  b: { x: 514, y: 19 },
  c: { x: 752, y: 546 },
  d: { x: 514, y: 546 },
};

export const webConfigs = {
  width: 1028,
  height: 680,
};

export const mainBallVelocities = {
  8: { x: 2.5, y: -2.6 },
  9: { x: 2.28, y: -2.6 },
  10: { x: 2.05, y: -2.6 },
  11: { x: 1.86, y: -2.6 },
  12: { x: 1.72, y: -2.6 },
  13: { x: 1.57, y: -2.6 },
  14: { x: 1.38, y: -2.6 },
  15: { x: 1.36, y: -2.6 },
  16: { x: 1.32, y: -2.6 },
};

export const mobileConfigs = {
  width: 574,
  height: 650,
};

export const colorsTopC = {
  darkOrange: '#FF8C00',
  coral: '#FF7F50',
  white: '#FFFFFF',
  red: '#b70000',
  [RiskType.low]: {
    circle: '#2ac923',
    bangCircleRGB: '#3eb639',
  },
  [RiskType.medium]: {
    circle: '#ff8818',
    bangCircleRGB: '#ce650c',
  },
  [RiskType.high]: {
    circle: '#d02828',
    bangCircleRGB: '#fd0303',
  },
};

export const colorsPG = {
  darkOrange: '#FF8C00',
  coral: '#FF7F50',
  white: '#FFFFFF',
  red: '#b70000',
  [RiskType.low]: {
    img: greenBall,
    circle: '#46FD5B',
    bangCircleRGB: '#55FE69',
  },
  [RiskType.medium]: {
    img: yellowBall,
    circle: '#FFF500',
    bangCircleRGB: '#FFF53E',
  },
  [RiskType.high]: {
    img: redBall,
    circle: '#FE0000',
    bangCircleRGB: '#FF6450',
  },
};
export const colorsVbet = {
  darkOrange: '#FF8C00',
  coral: '#FF7F50',
  white: '#FFFFFF',
  red: '#b70000',
  [RiskType.low]: {
    img: greenBall,
    circle: '#46FD5B',
    bangCircleRGB: '#55FE69',
  },
  [RiskType.medium]: {
    img: yellowBall,
    circle: '#FFF500',
    bangCircleRGB: '#FFF53E',
  },
  [RiskType.high]: {
    img: vbetBall,
    circle: '#8e0055',
    bangCircleRGB: '#DB0083',
  },
};

export const colorsPbet = {
  darkOrange: '#FF8C00',
  coral: '#FF7F50',
  white: '#FFFFFF',
  red: '#b70000',
  [RiskType.low]: {
    img: greenBall,
    circle: '#46FD5B',
    bangCircleRGB: '#55FE69',
  },
  [RiskType.medium]: {
    img: pBet,
    circle: '#FFF500',
    bangCircleRGB: '#FFF53E',
  },
  [RiskType.high]: {
    img: redBall,
    circle: '#FE0000',
    bangCircleRGB: '#FF6450',
  },
};

export const textureByProvider = (skin) => {
  if (skin === partnerSkinEnums.vbet || skin === partnerSkinEnums.bfth) {
    return colorsVbet;
  }
  if (skin === partnerSkinEnums.pbets) {
    return colorsPbet;
  }
  return colorsPG;
};

export const plinkoLines = [8, 9, 10, 11, 12, 13, 14, 15, 16];
